import React from 'react';

const RenewalSubmissionFormUploadInstructions = ()=> {
  return (
    <div>
      <div className="file-uploader__info-title">
        Please upload the last 3 months of complete bank statements
      </div>
    </div>
  );
};

export default RenewalSubmissionFormUploadInstructions;
